export default __webpack_public_path__ + "static/media/1006.837501c6.png";